import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { LinkBehaviour } from "../../components/LinkBehaviour";
import styles from "./Logo.module.scss";
export const Logo = ({ isDarkMode = false, link, srcDark, srcLight, title, alt, width, className, renderImage, }) => {
    const src = isDarkMode ? srcLight : srcDark;
    const ImageComponent = renderImage ? (renderImage({ src, alt, title, className: styles.image })) : (_jsx("img", { src: src, alt: alt, title: title, className: styles.image }));
    return (_jsx("div", { className: classnames(styles.logo, className), style: { width }, "data-testid": "brandLogo", children: _jsx(LinkBehaviour, { href: link, children: ImageComponent }) }));
};
//# sourceMappingURL=Logo.js.map